import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: column;

	width: 100%;
	height: 100%;

	background-color: #f5f5f5;

	font-family: "Mulish";

	padding: 1rem;

	.header {
		display: flex;

		font-size: 1.1rem;
		font-weight: bold;

		gap: 0.5rem;

		margin-bottom: 1rem;

		#name {
			color: #3751ff;
		}
	}
`;

export const Content = styled.div`
	display: flex;

	height: 90vh;

	gap: 1rem;

	.check-form {
		display: flex;
		flex-direction: column;

		width: 100%;
		height: 100%;

		background-color: white;

		border-radius: 0.5rem;
		border: 1px solid #dfe0eb;

		padding: 1rem;
	}

	.check-header,
	.buttons {
		display: flex;
		justify-content: space-between;
	}

	.check-header {
		display: flex;

		.teste {
			align-items: center;
			display: flex;

			color: red;

			svg {
				margin-right: 1rem;
			}
		}

		.buttons {
			button {
				display: flex;

				align-items: center;
				justify-content: center;

				border-radius: 0.3rem;

				margin: 0 0.5rem 0 0.5rem;

				height: 3rem;
				width: 3rem;

				transition: 0.15s;

				background: none;

				border: 1px solid #e0e0e0;
				color: #e0e0e0;
			}

			.edit:hover,
			.create.active:hover {
				background-color: #3751ff;
				color: white;
				cursor: pointer;
			}

			.active {
				border: 1px solid #3751ff;
				color: #3751ff;

				cursor: pointer;
			}

			.confirmation {
				width: 5rem;
			}

			.save.active.confirmation {
				border: 1px solid #1ed61a;
				color: #1ed61a;
			}

			.remove.active.confirmation {
				border: 1px solid #d61a1a;
				color: #d61a1a;
			}

			.edit.active.confirmation {
				border: 1px solid #d61a1a;
				color: #d61a1a;
			}

			.edit.active.confirmation:hover {
				background-color: #d61a1a;
				color: white;
			}
		}
	}

	.questWrapper::-webkit-scrollbar {
		width: 0.5rem;
		height: 100%;
	}

	.questWrapper::-webkit-scrollbar-thumb {
		background-color: #e7e7e7;
		border-radius: 1rem;
	}

	.questWrapper {
		position: relative;

		width: 100%;
		height: 100%;

		overflow-y: scroll;

		font-size: 1.2rem;
		font-weight: bold;

		padding-bottom: 5rem;

		table {
			white-space: nowrap;

			width: 100%;

			border-collapse: collapse;

			font-family: Mulish;
			color: #28376b;

			overflow-x: scroll;

			::-webkit-scrollbar {
				height: 0.5rem;
			}

			tr {
				height: 5rem;
			}

			.question-row {
				border-top: 1px solid #e0e0e0;

				&:hover {
					background-color: #efefef;
				}

				td > input {
					background: none;
					border: none;

					width: 100%;

					color: #28376b;
					font-size: 1.2rem;
				}
			}

			th {
				position: -webkit-sticky;
				position: sticky;

				top: 0;
				z-index: 10;
				background-color: white;

				font-weight: 700;

				text-align: left;
			}

			td {
				font-weight: 400;
			}

			th,
			td {
				padding: 1rem 0.5rem 1rem 1rem;

				min-width: 25px;
				max-width: 300px;
			}
		}

		.empty-table {
			display: flex;
			flex-direction: column;

			color: #d6d7e0;

			margin-top: 12.5vh;

			align-items: center;

			font-size: 1.5rem;
			font-weight: 700;

			#question-icon {
				height: 10rem;
				width: 10rem;

				margin-bottom: 1rem;
			}
		}
	}

	#custom-select {
		min-width: 150px;
		max-width: 300px;
	}

	#document-select {
		width: 20%;

		min-width: 250px;
		max-width: 300px;
	}
`;
